import { ApiResponse, GlobalStore, GridStore } from "@roc/feature-app-core";
import { NewLeadService } from "@roc/feature-new-lead";
import { GENERIC_ERROR_MESSAGE } from "@roc/feature-utils";
import { computed, flow, makeObservable, observable } from "mobx";
import { LEAD_OBJECT_TYPE } from "../components/leads/constants/constants";
import { DEFAULT_SORT_BY, DEFAULT_SORT_DIR, getDefaultSortBy, getSortOptions, SortDirection } from "../components/leadsDashboard/leadsDashboardSortOptions";
import { LeadsDashboardService } from "../services/leadsDashboardService";
import { LeadsDashboardStore } from "./leadsDashboardStore";
import { BaseLeadStore } from "libs/client-portal-shared/src/app/modules/companyProfile/stores/baseLeadStore/BaseLeadStore";

const PAGE_SIZE = 50;
export class LeadsDashboardGridStore extends GridStore {
  private globalStore: GlobalStore;
  private leadsDashboardStore: LeadsDashboardStore;
  private leadsDashboardService: LeadsDashboardService;
  private newLeadService: NewLeadService;
  private leadStore: BaseLeadStore;

  sortBy: string = DEFAULT_SORT_BY;
  sortDir: SortDirection = DEFAULT_SORT_DIR;

  constructor(globalStore: GlobalStore, leadsDashboardStore, leadStore: BaseLeadStore) {
    super(() => this.fetchRows(), undefined, PAGE_SIZE);
    this.globalStore = globalStore;
    this.leadsDashboardStore = leadsDashboardStore;
    this.leadsDashboardService = new LeadsDashboardService();
    this.newLeadService = new NewLeadService();
    this.leadStore = leadStore;

    makeObservable(this, {
      sortBy: observable,
      sortDir: observable,
      isLeadDashboard: computed,
      sortOptions: computed,
      activeSortBy: computed,
      setSort: flow,
    });
  }

  get isLeadDashboard() {
    const { currentDashboard } = this.leadsDashboardStore;
    return currentDashboard?.objectType?.toUpperCase() === LEAD_OBJECT_TYPE
      || currentDashboard?.baseObject?.toUpperCase() === LEAD_OBJECT_TYPE;
  }

  get sortOptions() {
    return getSortOptions(this.isLeadDashboard);
  }

  get activeSortBy() {
    return this.sortOptions.some(option => option.value === this.sortBy)
      ? this.sortBy
      : getDefaultSortBy(this.sortOptions);
  }

  *setSort(sortBy: string, sortDir: SortDirection) {
    this.sortBy = sortBy;
    this.sortDir = sortDir;
    yield this.setPageNumber(1);
  }

  fetchRows = async () => {
    try {
      if (this.leadsDashboardStore.isCustomDashboard) {
        return await this.fetchCustomDashboard();
      } else {
        return await this.fetchStandardDashboard()
      }
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE
      });
    }
  };


  fetchStandardDashboard = async () => {
    const { currentDashboard } = this.leadsDashboardStore;
    const response: ApiResponse = await this.newLeadService.getLeadsListById(
      currentDashboard.dashboardListId,
      this.gridData.meta.pageNumber,
      this.gridData.meta.pageSize,
      this.activeSortBy,
      this.sortDir,
      this.gridData.meta.filters,
      this.gridData.meta.dropdownFilters,
      this.leadStore.gridBusinessUnit
    );
    return response;
  }


  fetchCustomDashboard = async () => {
    const { currentDashboard } = this.leadsDashboardStore;

    const dashboardData = {
      ...currentDashboard,
      creationDate: undefined,
      lastUpdatedDate: undefined
    }

    const response = await this.leadsDashboardService.getCustomDashboardDataById(
      dashboardData,
      this.gridData.meta.pageNumber,
      this.gridData.meta.pageSize,
      this.sortDir,
      this.activeSortBy,
      this.gridData.meta.filters,
      this.gridData.meta.dropdownFilters,
      this.leadStore.gridBusinessUnit
    );
    const data = JSON.parse(response.data.data);
    return new ApiResponse({ data }, null);
  }
}